<template>
  <form ref="oneoff_new">
    <div class="card__header">
      <p class="card__title">Update single delivery</p>
    </div>
    <div class="card__content">
      <p class="card__subheader">Original basket</p>
      <div class="card card--xs card--noShadow fill--paper">
        <div class="card__content">
          <div v-for="item in originalCart">
            {{ item.product_name }} x {{ item.qty }}
          </div>
        </div>
      </div>
    </div>

    <div class="card__content">
      <p class="card__subheader">Select your additional products</p>
      <ul class="tabs tabs--sm nav" id="productsNav" role="tablist">
        <li class="tab__wrapper" role="presentation" v-for="(tab, index) in tabs">
          <a v-if="tab" :class="['tab', (index == Object.keys(tabs)[0] ? 'active' : '')]" :id="tab.category.slug+'-tab'" data-toggle="tab" :href="'#'+tab.category.slug" role="tab">
            {{ tab.category.name }}
          </a>
        </li>
      </ul>
      <div class="tabs__content" id="myTabContent">
        <div v-for="(tab, index) in tabs" v-if="tab" :class="['tab__target', (index == Object.keys(tabs)[0] ? 'show active' : '')]" :id="tab.category.slug" role="tabpanel">
          <div class="row product__infosWrapper">
            <div class="col-md-6" v-for="product in tab.products">
              <div class="product__infos" :class="{ 'product__unavailable': !product.can_sale }">
                <div class="product__image"><img :src="'/' + product.image" class="img-fluid" alt=""></div>
                <div class="product__meta">
                  <div class="product__header">
                    <p class="text-16 product__title">{{ product.name }}</p>
                    <div class="qty__wrapper" v-if="product.can_sale">
                      <button type="button" class="button button--sm button--icon button--grey"
                              v-on:click="setQuantity(product, 'ACTION_LESS')">
                        <icon-minus></icon-minus>
                      </button>
                      <p class="text-16 qty">{{ $parent.cart[product.id].qty }}</p>
                      <button type="button" class="button button--sm button--icon button--grey"
                              v-on:click="setQuantity(product, 'ACTION_MORE')">
                        <icon-plus></icon-plus>
                      </button>
                    </div>
                  </div>
                  <div>
                    <div class="text-12">
                      <template v-if="product.food_pairing">
                        {{ product.food_pairing }}. 
                      </template>
                      <v-clamp autoresize :max-lines="3">
                        {{ product.description_short }}
                        <template #after="{ toggle, clamped, expanded }">
                          <button v-if="clamped == true || expanded == true" @click="toggle" type="button" class="product__expand button button--xs button--icon button--grey">
                            <template v-if="clamped == true"><icon-chevron-down></icon-chevron-down></template>
                            <template v-else><icon-chevron-up></icon-chevron-up></template>
                          </button>
                        </template>
                      </v-clamp>
                    </div>
                    <div class="mt-05">
                      <!-- product discount -->
                      <!-- <p class="tag tag--sm tag--primary" v-if="product.id === 27 || product.id === 26 || product.id === 53 || product.id === 85 || product.id === 86">15% off</p> -->
                      <span class="text-14 text--bold">
                        £{{ product.price | setDecimals }}
                        <!-- product discount -->
                        <!-- <span class="text--strikeThrough text--regular text--alt">
                          <template v-if="product.id === 27">£4.75</template>
                          <template v-if="product.id === 26">£5.20</template>
                          <template v-if="product.id === 53">£4.75</template>
                          <template v-if="product.id === 85">£4.20</template>
                          <template v-if="product.id === 86">£4.20</template>
                        </span> -->
                      </span>
                    </div>
                    <p class="text-12 text-error mt-05 text--bold" v-if="product.is_tracked && product.stock === 0">Out of stock</p>
                    <p class="text-12 text-error mt-05 text--bold" v-else-if="product.is_tracked && (product.stock - product.qty) === 0">Out of stock</p>
                    <p class="text-12 text-error mt-05 text--bold" v-else-if="product.is_tracked && product.stock <= 5">Only {{ product.stock - product.qty }} remaining</p>
                    <p class="text-12 mt-05">
                      <template v-if="product.start_sale || product.end_sale">
                        Available
                        <span v-if="product.start_sale">From {{ dateFormat(product.start_sale) }}</span>
                        <span v-if="product.end_sale">to {{ dateFormat(product.end_sale) }}</span>
                      </template>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p class="form__notice form__notice--error mt-3 js-order-error" style="display: none;">Please select at least 1 product</p>
    </div>
    <div class="card__actions">
      <button type="button" class="button button--md button--secondary" v-on:click="nextStep()">Next</button>
    </div>
  </form>
</template>

<script>

import VClamp from 'vue-clamp'

export default {

  components: {
    VClamp
  },

  data() {
    return {
      deliveryDateError: false,
      startDate: null,
      originalCart: [],
      tabs: [],
    }
  },

  beforeMount() {
    this.$parent.products.map((p) => {
      p.categories.map((c) => {
        if (!this.tabs[c.id]) {
          this.tabs[c.id] = {
            category: c,
            products: [],
          };
        }
        this.tabs[c.id].products.push(p);
      });
    });

    this.tabs = this.tabs.sort((a,b) => {
      return a.category.rgt - b.category.rgt;
    });
  },

  mounted() {
    if (this.$parent.date) {
      this.$parent.updateProductsPeriodAvailability(moment(this.$parent.date, 'DD/MM/YYYY').toDate());
    }

    this.$parent.order.items.forEach((item) => {
      item = { ...item }; // clone item object
      let extraProduct = this.$parent.order.extra_products.find((extra) => extra.product_id === item.product_id);

      if (extraProduct) {
        item.qty -= extraProduct.qty;
      }

      if (item.qty > 0) {
        this.originalCart.push(item);
      }
    });
  },

  methods: {
    setQuantity(product, action) {
      if (action === 'ACTION_MORE') {
        if (this.$parent.cart[product.id].qty < 15) {
          if (product.is_tracked) {
            if (this.$parent.cart[product.id].qty < product.stock) {
              this.$parent.cart[product.id].qty++;
            }
          }
          else {
            this.$parent.cart[product.id].qty++;
          }
        }

        $('.js-order-error').fadeOut();
      } else {
        if (this.$parent.cart[product.id].qty > 0) {
          this.$parent.cart[product.id].qty--;
        }
      }

      this.$parent.promotion_total = null;
      this.$parent.total = null;
    },

    nextStep() {
      if (!$(this.$refs.oneoff_new).valid()) return false;

      $('.js-order-error').fadeOut();

      if (this.$parent.promotion_code) {
        // this.$parent.validateOrder();
      }

      this.$parent.step = 'SUMMARY';
    },

    dateFormat(date) {
      function pad(s) { return (s < 10) ? '0' + s : s; }
      let d = new Date(date);
      return [pad(d.getDate()), pad(d.getMonth()+1)].join('/');
    }
  }

}
</script>
